@if (type() === navbarTypeEnum.ECOMMERCE) {
  <div class="relative bg-bg shadow">
    <div class="max-w-7xl mx-auto px-1 sm:px-6">
      <div
        class="flex justify-between items-center max-sm:py-4 py-6 lg:justify-start md:space-x-10"
      >
        <div class="flex justify-between lg:w-0 lg:flex-1 w-full">
          <div class="flex items-center">
            <div class="lg:hidden flex items-center">
              <button
                type="button"
                (click)="toggleNavbar()"
                class="bg-bg rounded-md p-2 inline-flex items-center justify-center text-fg-subtle hover:text-fg-subtle hover:bg-bg-alt focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-hover"
                aria-expanded="false"
              >
                <span class="sr-only">Open menu</span>
                <!-- Heroicon name: outline/menu -->
                <ml-icon name="menu" class="h-6 w-6" />
              </button>
            </div>

            <a [routerLink]="['/']" class="flex items-center">
              <ml-logo
                class="sm:h-6 h-4 w-auto text-fg ml-2"
                label="Magrolabs"
              />
            </a>
          </div>

          <div class="flex items-center">
            <div class="relative lg:hidden block">
              <div>
                <button
                  type="button"
                  class="bg-bg m-2 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                  id="user-menu-button"
                  aria-expanded="false"
                  aria-haspopup="true"
                  (click)="toggleUserMenu()"
                >
                  <span class="sr-only">Abrir menú de usuario</span>
                  <ml-icon name="user-circle-outline" class="h-8 w-8" />
                </button>
              </div>

              @if (isUserMenuOpen) {
                @if (isAuthenticated) {
                  <div
                    class="z-50 origin-top-right absolute right-0 w-56 rounded-md shadow-lg py-1 bg-bg ring-1 ring-black ring-opacity-5 focus:outline-none"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="user-menu-button"
                    tabindex="-1"
                  >
                    <div class="px-4 py-3 border-b border-border">
                      <div class="text-base font-medium text-fg">
                        {{ user?.first_name || "Usuario" }}
                        {{ user?.last_name || "" }}
                      </div>
                      <div class="text-xs font-medium text-fg-subtle">
                        {{ user?.email || "usuario@ejemplo.com" }}
                      </div>
                    </div>
                    <a
                      routerLink="/cuenta/mi-cuenta"
                      class="flex px-4 py-2 text-sm text-fg-muted hover:bg-bg-alt"
                      role="menuitem"
                      tabindex="-1"
                      id="user-menu-item-1"
                    >
                      <ml-icon name="home" class="h-5 w-5" />
                      &nbsp;Inicio
                    </a>
                    <a
                      routerLink="/cuenta/perfil"
                      class="flex px-4 py-2 text-sm text-fg-muted hover:bg-bg-alt"
                      role="menuitem"
                      tabindex="-1"
                      id="user-menu-item-0"
                    >
                      <ml-icon name="profile" class="h-5 w-5" />
                      &nbsp; Perfil
                    </a>
                    <button
                      type="button"
                      (click)="logout()"
                      class="flex w-full px-4 py-2 text-sm text-red-600 hover:bg-bg-alt cursor-pointer text-left"
                      role="menuitem"
                      tabindex="-1"
                      id="user-menu-item-2"
                    >
                      <ml-icon name="logout" class="h-5 w-5" />
                      &nbsp;Cerrar sesión
                    </button>
                  </div>
                } @else {
                  <div
                    class="origin-top-right absolute right-0 w-56 rounded-md shadow-lg py-1 bg-bg ring-1 ring-black ring-opacity-5 focus:outline-none"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="user-menu-button"
                    tabindex="-1"
                  >
                    <div
                      class="flex flex-col items-center justify-center px-4 py-3 gap-6"
                    >
                      <a
                        [routerLink]="'/login'"
                        routerLinkActive="text-primary"
                        class="whitespace-nowrap text-base font-medium text-fg-subtle hover:text-fg"
                      >
                        Iniciar sesión
                      </a>

                      <ml-button
                        class="mx-6"
                        name="Regístrate"
                        [routerLink]="'/registro'"
                        type="secondary-outlined"
                      />
                    </div>
                  </div>
                }
              }
            </div>

            @if (!isCheckout()) {
              <button
                type="button"
                class="transition duration-500 hover:scale-105 flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse relative lg:hidden"
                (click)="verCarrito()"
                [ngClass]="{ 'animate-pulse': isLoading }"
              >
                <div
                  [@cartAnimation]="cartState"
                  class="rounded-full w-[50px] h-[50px] p-2 flex items-center justify-center object-center"
                >
                  <ml-icon name="shopping-cart" class="h-7 w-7 text-fg" />
                </div>
                <div
                  class="bg-primary absolute top-0 right-0 flex rounded-full h-[18px] w-[18px] text-white text-center justify-center"
                >
                  <p class="self-center text-center text-xs">
                    {{ numItemsCart }}
                  </p>
                </div>
              </button>
            }
          </div>
        </div>
      </div>
    </div>

    <div
      [@fadeInOut]="state"
      class="lg:hidden fixed inset-0 overflow-hidden z-30"
      role="button"
      tabindex="0"
      aria-label="Cerrar menú de navegación"
      (click)="state = 'inactive'"
      (keydown.escape)="state = 'inactive'"
    >
      <div class="absolute top-0 inset-x-0 z-10 p-2 origin-top-right lg:hidden">
        <div
          class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-bg divide-y-2 divide-bg-alt"
          role="dialog"
          aria-label="Menú de navegación"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
        >
          <div class="pt-5 pb-6 px-5">
            <div class="flex items-center justify-between">
              <div class="-mr-2">
                <button
                  type="button"
                  (click)="toggleNavbar()"
                  class="bg-bg rounded-md p-2 inline-flex items-center justify-center text-fg-subtle hover:text-fg-subtle hover:bg-bg-alt focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-hover"
                >
                  <span class="sr-only">Close menu</span>
                  <ml-icon name="close" class="h-6 w-6" />
                </button>
              </div>

              <div>
                <ml-logo class="h-3 w-auto text-fg" label="Magrolabs" />
              </div>
            </div>
          </div>
          <div class="py-6 px-5 space-y-6">
            <div class="grid grid-cols-1 gap-y-8 gap-x-8">
              <a
                [routerLink]="['/atencion-cliente/como-funciona']"
                routerLinkActive="text-primary"
                class="text-base font-medium text-fg-subtle hover:text-fg"
              >
                ¿Cómo funciona?
              </a>
              <a
                [routerLink]="['/atencion-cliente']"
                routerLinkActive="text-primary"
                class="text-base font-medium text-fg-subtle hover:text-fg"
              >
                Atención al Cliente
              </a>
              <a
                [routerLink]="['/productos']"
                routerLinkActive="text-primary"
                class="text-base font-medium text-fg-subtle hover:text-fg"
              >
                Tienda
              </a>
              <a
                [routerLink]="['/blog']"
                routerLinkActive="text-primary"
                class="text-base font-medium text-fg-subtle hover:text-fg"
              >
                Blog
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-cart />
}
@if (type() === navbarTypeEnum.LANDING) {
  @if (ENV.isBlackFridayActive) {
    <app-black-friday-bar></app-black-friday-bar>
  } @else {
    <app-urgency-bar></app-urgency-bar>
  }

  <div class="fixed top-[50px] left-0 right-0 z-[60]">
    <div class="relative bg-bg shadow">
      <div class="max-w-7xl mx-auto px-1 sm:px-6">
        <div
          class="flex justify-between items-center max-sm:py-1 py-2 lg:justify-start md:space-x-10"
        >
          <div class="flex justify-between lg:w-0 lg:flex-1 w-full">
            <div class="flex items-center">
              <div class="lg:hidden flex items-center">
                <button
                  type="button"
                  (click)="toggleNavbar()"
                  class="bg-bg rounded-md p-2 inline-flex items-center justify-center text-fg-subtle hover:text-fg-subtle hover:bg-bg-alt focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-hover"
                  aria-expanded="false"
                >
                  <span class="sr-only">Open menu</span>
                  <!-- Heroicon name: outline/menu -->
                  <ml-icon name="menu" class="h-6 w-6" />
                </button>
              </div>

              <a [routerLink]="['/']" class="flex items-center">
                <ml-logo
                  class="sm:h-6 h-4 w-auto text-fg ml-2"
                  label="Magrolabs"
                />
              </a>
            </div>

            <div class="flex items-center">
              <div class="relative lg:hidden block">
                <div>
                  <button
                    type="button"
                    class="bg-bg m-2 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    id="user-menu-button"
                    aria-expanded="false"
                    aria-haspopup="true"
                    (click)="toggleUserMenu()"
                  >
                    <span class="sr-only">Abrir menú de usuario</span>
                    <ml-icon name="user-circle-outline" class="h-8 w-8" />
                  </button>
                </div>

                @if (isUserMenuOpen) {
                  @if (isAuthenticated) {
                    <div
                      class="z-10 origin-top-right absolute right-0 w-56 rounded-md shadow-lg py-1 bg-bg ring-1 ring-black ring-opacity-5 focus:outline-none"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="user-menu-button"
                      tabindex="-1"
                    >
                      <div class="px-4 py-3 border-b border-border">
                        <div class="text-base font-medium text-fg">
                          {{ user?.first_name || "Usuario" }}
                          {{ user?.last_name || "" }}
                        </div>
                        <div class="text-xs font-medium text-fg-subtle">
                          {{ user?.email || "usuario@ejemplo.com" }}
                        </div>
                      </div>
                      <a
                        routerLink="/cuenta/mi-cuenta"
                        class="flex px-4 py-2 text-sm text-fg-muted hover:bg-bg-alt"
                        role="menuitem"
                        tabindex="-1"
                        id="user-menu-item-1"
                      >
                        <ml-icon name="home" class="h-5 w-5" />
                        &nbsp;Inicio
                      </a>
                      <a
                        routerLink="/cuenta/perfil"
                        class="flex px-4 py-2 text-sm text-fg-muted hover:bg-bg-alt"
                        role="menuitem"
                        tabindex="-1"
                        id="user-menu-item-0"
                      >
                        <ml-icon name="profile" class="h-5 w-5" />
                        &nbsp; Perfil
                      </a>
                      <button
                        type="button"
                        (click)="logout()"
                        class="flex w-full px-4 py-2 text-sm text-red-600 hover:bg-bg-alt cursor-pointer text-left"
                        role="menuitem"
                        tabindex="-1"
                        id="user-menu-item-2"
                      >
                        <ml-icon name="logout" class="h-5 w-5" />
                        &nbsp;Cerrar sesión
                      </button>
                    </div>
                  } @else {
                    <div
                      class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg py-1 bg-bg ring-1 ring-black ring-opacity-5 focus:outline-none"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="user-menu-button"
                      tabindex="-1"
                    >
                      <div
                        class="flex flex-col items-center justify-center px-4 py-3 gap-6"
                      >
                        <a
                          [routerLink]="'/login'"
                          routerLinkActive="text-primary"
                          class="whitespace-nowrap text-base font-medium text-fg-subtle hover:text-fg"
                        >
                          Iniciar sesión
                        </a>

                        <ml-button
                          class="mx-6"
                          name="Regístrate"
                          [routerLink]="'/registro'"
                          type="secondary-outlined"
                        />
                      </div>
                    </div>
                  }
                }
              </div>

              @if (!isCheckout()) {
                <button
                  type="button"
                  class="transition duration-500 hover:scale-105 flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse relative lg:hidden"
                  (click)="verCarrito()"
                  [ngClass]="{ 'animate-pulse': isLoading }"
                >
                  <div
                    [@cartAnimation]="cartState"
                    class="rounded-full w-[50px] h-[50px] p-2 flex items-center justify-center object-center"
                  >
                    <ml-icon name="shopping-cart" class="h-7 w-7 text-fg" />
                  </div>
                  <div
                    class="bg-primary absolute top-0 right-0 flex rounded-full h-[18px] w-[18px] text-white text-center justify-center"
                  >
                    <p class="self-center text-center text-xs">
                      {{ numItemsCart }}
                    </p>
                  </div>
                </button>
              }
            </div>
          </div>

          <nav class="hidden lg:flex space-x-10">
            <a
              [routerLink]="['/atencion-cliente/como-funciona']"
              routerLinkActive="text-primary"
              class="text-base font-medium text-fg-subtle hover:text-fg"
            >
              ¿Cómo funciona?
            </a>
            <a
              [routerLink]="['/atencion-cliente']"
              routerLinkActive="text-primary"
              class="text-base font-medium text-fg-subtle hover:text-fg"
            >
              Atención al Cliente
            </a>
            <a
              [routerLink]="['/productos']"
              routerLinkActive="text-primary"
              class="text-base font-medium text-fg-subtle hover:text-fg"
            >
              Tienda
            </a>
            <a
              [routerLink]="['/blog']"
              routerLinkActive="text-primary"
              class="text-base font-medium text-fg-subtle hover:text-fg"
            >
              Blog
            </a>
          </nav>
          <div class="hidden lg:flex items-center justify-end md:flex-1 lg:w-0">
            @if (!isAuthenticated) {
              <a
                [routerLink]="'/login'"
                routerLinkActive="text-primary"
                class="whitespace-nowrap text-base font-medium text-fg-subtle hover:text-fg"
              >
                Iniciar sesión
              </a>

              <ml-button
                class="mx-6"
                name="Regístrate"
                [routerLink]="'/registro'"
                type="secondary-outlined"
              />
            } @else {
              <div class="ml-3 relative">
                @if (isUserMenuOpen) {
                  <div
                    class="origin-top-right absolute z-50 right-0 mt-12 w-56 rounded-md shadow-lg py-1 bg-bg ring-1 ring-black ring-opacity-5 focus:outline-none"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="user-menu-button"
                    tabindex="-1"
                  >
                    <div class="px-4 py-3 border-b border-border">
                      <div class="text-base font-medium text-fg">
                        {{ user?.first_name || "Usuario" }}
                        {{ user?.last_name || "" }}
                      </div>
                      <div class="text-xs font-medium text-fg-subtle">
                        {{ user?.email || "usuario@ejemplo.com" }}
                      </div>
                    </div>
                    <a
                      routerLink="/cuenta/mi-cuenta"
                      class="flex px-4 py-2 text-sm text-fg-muted hover:bg-bg-alt"
                      role="menuitem"
                      tabindex="-1"
                      id="user-menu-item-1"
                    >
                      <ml-icon name="home" class="h-5 w-5" />
                      &nbsp;Inicio
                    </a>
                    <a
                      routerLink="/cuenta/perfil"
                      class="flex px-4 py-2 text-sm text-fg-muted hover:bg-bg-alt"
                      role="menuitem"
                      tabindex="-1"
                      id="user-menu-item-0"
                    >
                      <ml-icon name="profile" class="h-5 w-5" />
                      &nbsp; Perfil
                    </a>
                    <button
                      type="button"
                      (click)="logout()"
                      class="flex w-full px-4 py-2 text-sm text-red-600 hover:bg-bg-alt cursor-pointer text-left"
                      role="menuitem"
                      tabindex="-1"
                      id="user-menu-item-2"
                    >
                      <ml-icon name="logout" class="h-5 w-5" />
                      &nbsp;Cerrar sesión
                    </button>
                  </div>
                }
                <div>
                  <button
                    type="button"
                    class="bg-bg flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    id="user-menu-button"
                    aria-expanded="false"
                    aria-haspopup="true"
                    (click)="toggleUserMenu()"
                  >
                    <span class="sr-only">Abrir menú de usuario</span>
                    <ml-icon name="user-circle-outline" class="h-10 w-10" />
                  </button>
                </div>
              </div>
            }

            @if (!isCheckout()) {
              <button
                type="button"
                class="transition duration-500 hover:scale-105 flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse relative"
                (click)="verCarrito()"
                [ngClass]="{ 'animate-pulse': isLoading }"
              >
                <div
                  [@cartAnimation]="cartState"
                  class="rounded-full w-[50px] h-[50px] p-2 flex items-center justify-center object-center"
                >
                  <ml-icon name="shopping-cart" class="h-12 w-12 text-fg" />
                </div>
                <div
                  class="bg-primary absolute top-0 right-0 flex rounded-full h-[23px] w-[23px] text-fg text-center justify-center"
                >
                  <p class="self-center text-center text-xs">
                    {{ numItemsCart }}
                  </p>
                </div>
              </button>
            }
          </div>
        </div>
      </div>

      <div
        [@fadeInOut]="state"
        class="lg:hidden fixed inset-0 overflow-hidden z-30"
        role="button"
        tabindex="0"
        aria-label="Cerrar menú de navegación"
        (click)="state = 'inactive'"
        (keydown.escape)="state = 'inactive'"
      >
        <div
          class="absolute top-0 inset-x-0 z-10 p-2 origin-top-right lg:hidden"
        >
          <div
            class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-bg divide-y-2 divide-bg-alt"
            role="dialog"
            aria-label="Menú de navegación"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          >
            <div class="pt-5 pb-6 px-5">
              <div class="flex items-center justify-between">
                <div class="-mr-2">
                  <button
                    type="button"
                    (click)="toggleNavbar()"
                    class="bg-bg rounded-md p-2 inline-flex items-center justify-center text-fg-subtle hover:text-fg-subtle hover:bg-bg-alt focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-hover"
                  >
                    <span class="sr-only">Close menu</span>
                    <ml-icon name="close" class="h-6 w-6" />
                  </button>
                </div>

                <div>
                  <ml-logo class="h-3 w-auto text-fg" label="Magrolabs" />
                </div>
              </div>
            </div>
            <div class="py-6 px-5 space-y-6">
              <div class="grid grid-cols-1 gap-y-8 gap-x-8">
                <a
                  [routerLink]="['/atencion-cliente/como-funciona']"
                  routerLinkActive="text-primary"
                  class="text-base font-medium text-fg-subtle hover:text-fg"
                >
                  ¿Cómo funciona?
                </a>
                <a
                  [routerLink]="['/atencion-cliente']"
                  routerLinkActive="text-primary"
                  class="text-base font-medium text-fg-subtle hover:text-fg"
                >
                  Atención al Cliente
                </a>
                <a
                  [routerLink]="['/productos']"
                  routerLinkActive="text-primary"
                  class="text-base font-medium text-fg-subtle hover:text-fg"
                >
                  Tienda
                </a>
                <a
                  [routerLink]="['/blog']"
                  routerLinkActive="text-primary"
                  class="text-base font-medium text-fg-subtle hover:text-fg"
                >
                  Blog
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-cart />
  </div>

  <div class="h-[50px] mt-[60px]"></div>
}
@if (type() === navbarTypeEnum.BOLSA) {
  <div class="relative bg-bg shadow">
    <div
      class="flex justify-between items-center max-sm:py-4 p-6 lg:justify-start md:space-x-10"
    >
      <a [routerLink]="['/']" class="flex items-center mx-auto">
        <ml-logo class="sm:h-5 h-4 w-auto text-fg ml-2" label="Magrolabs" />
      </a>
    </div>
  </div>
}
